var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('supplier-info-form',{ref:"supplierInfoForm",attrs:{"sourceType":_vm.sourceType,"submitData":_vm.submitData,"data":_vm.data,"isClothingCategory":_vm.isClothingCategory,"cacheable":_vm.cacheable},on:{"cacheRecovered":_vm.handleCacheRecovered,"formDataChange":_vm.handleFormDataChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }